/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TableColumnMappingDto } from './TableColumnMappingDto';
import {
    TableColumnMappingDtoFromJSON,
    TableColumnMappingDtoFromJSONTyped,
    TableColumnMappingDtoToJSON,
    TableColumnMappingDtoToJSONTyped,
} from './TableColumnMappingDto';
import type { TableColumnFilterDto } from './TableColumnFilterDto';
import {
    TableColumnFilterDtoFromJSON,
    TableColumnFilterDtoFromJSONTyped,
    TableColumnFilterDtoToJSON,
    TableColumnFilterDtoToJSONTyped,
} from './TableColumnFilterDto';

/**
 * One variant of a configuration for automatically creating table rows based on source table data
 * @export
 * @interface TableRowPresetDto
 */
export interface TableRowPresetDto {
    /**
     * Reference to source table element to pull rows from
     * @type {string}
     * @memberof TableRowPresetDto
     */
    sourceTableReference?: string;
    /**
     * 
     * @type {TableColumnFilterDto}
     * @memberof TableRowPresetDto
     */
    sourceTableRowFilter?: TableColumnFilterDto;
    /**
     * 
     * @type {Array<TableColumnMappingDto>}
     * @memberof TableRowPresetDto
     */
    columnMappings?: Array<TableColumnMappingDto>;
    /**
     * If true, users can manually add or remove rows. If false, rows are fully controlled by the source table.
     * @type {boolean}
     * @memberof TableRowPresetDto
     */
    canAddRows?: boolean;
    /**
     * When true, matching source rows are not applied automatically — the user must confirm the carry-over explicitly (used for schlank→ausführlich LuV path switches).
     * @type {boolean}
     * @memberof TableRowPresetDto
     */
    requiresConfirmation?: boolean;
}

/**
 * Check if a given object implements the TableRowPresetDto interface.
 */
export function instanceOfTableRowPresetDto(value: object): value is TableRowPresetDto {
    return true;
}

export function TableRowPresetDtoFromJSON(json: any): TableRowPresetDto {
    return TableRowPresetDtoFromJSONTyped(json, false);
}

export function TableRowPresetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableRowPresetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceTableReference': json['sourceTableReference'] == null ? undefined : json['sourceTableReference'],
        'sourceTableRowFilter': json['sourceTableRowFilter'] == null ? undefined : TableColumnFilterDtoFromJSON(json['sourceTableRowFilter']),
        'columnMappings': json['columnMappings'] == null ? undefined : ((json['columnMappings'] as Array<any>).map(TableColumnMappingDtoFromJSON)),
        'canAddRows': json['canAddRows'] == null ? undefined : json['canAddRows'],
        'requiresConfirmation': json['requiresConfirmation'] == null ? undefined : json['requiresConfirmation'],
    };
}

export function TableRowPresetDtoToJSON(json: any): TableRowPresetDto {
    return TableRowPresetDtoToJSONTyped(json, false);
}

export function TableRowPresetDtoToJSONTyped(value?: TableRowPresetDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceTableReference': value['sourceTableReference'],
        'sourceTableRowFilter': TableColumnFilterDtoToJSON(value['sourceTableRowFilter']),
        'columnMappings': value['columnMappings'] == null ? undefined : ((value['columnMappings'] as Array<any>).map(TableColumnMappingDtoToJSON)),
        'canAddRows': value['canAddRows'],
        'requiresConfirmation': value['requiresConfirmation'],
    };
}

